<template>
  <span class="countdown-timer" :class="{ 'error': distance < 60000, 'done': distance <= 0 }">
    <icon class="icon" name="schedule" />
    <span class="text">{{ countdownDisplay }}</span>
  </span>
</template>

<script>
import Icon from './Icon';

export default {
  components: {
    Icon,
  },

  props: {
    endTime: Date,
  },

  data() {
    return {
      countdownDate: '',
      distance: 0,
      timer: null,
    };
  },

  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },

  watch: {
    endTime: {
      handler() {
        clearInterval(this.timer);
        this.countdownDate = new Date(this.endTime).getTime();
        this.countdown();
        this.timer = setInterval(this.countdown, 1000);
      },
      immediate: true,
    },
  },

  computed: {
    seconds() {
      return Math.max(Math.floor((this.distance % (1000 * 60)) / 1000), 0);
    },

    minutes() {
      return Math.max(Math.floor((this.distance % (1000 * 60 * 60)) / (1000 * 60)), 0);
    },

    hours() {
      return Math.max(Math.floor((this.distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)), 0);
    },

    days() {
      return Math.max(Math.floor(this.distance / (1000 * 60 * 60 * 24)), 0);
    },

    countdownDisplay() {
      if (this.distance <= 0) {
        return 'Ended';
      }

      let countdownDisplay = '';

      if (this.days) {
        countdownDisplay = `${this.days}d `;
      }

      if (this.hours) {
        countdownDisplay += `${this.hours}h `;
      }

      if (this.minutes && !this.days) {
        countdownDisplay += `${this.minutes}m `;
      }

      if (this.seconds && !this.days && !this.hours) {
        countdownDisplay += `${this.seconds}s `;
      }

      return countdownDisplay;
    },
  },

  methods: {
    countdown() {
      const now = new Date().getTime();
      this.distance = this.countdownDate - now;

      if (this.distance < 0) {
        this.$emit('refresh');
        clearInterval(this.timer);
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.countdown-timer {
  position: relative;
  display: inline-flex;
  line-height: 1;
  align-items: center;
}

.icon {
  font-size: 20px;
}

.text {
  font-weight: bold;
  font-size: 14px;
  margin-left: $gp * .25;
}

.done {
  color: $color-gray-5 !important;
}
</style>
